if(typeof Checkout != 'undefined') {
	Checkout.$(document).on('page:load page:change', function() {
		console.log("loaded~")
    if($('tr.product').length > 0) {
      $('tr.product').hide();


    }
	});
}


// WEBPACK FOOTER //
// ../assets/js/checkout.js